const login = r => require.ensure([], () => r(require('../page/login.vue')));
const notFound = r => require.ensure([], () => r(require('../page/404.vue')));
const home = r => require.ensure([], () => r(require('../page/home.vue')));
const index = r => require.ensure([], () => r(require('../page/index.vue')));

let routes = [
    // {path: '/login', component: login, name: 'login', meta: {disableTab: true}},
    {path: '/404', component: notFound, name: 'notFound'},
    { path: '/', component: home,name:'home' },
     { path: '/login', redirect: { name: 'home' } }

];

export default routes;



// WEBPACK FOOTER //
// ./src/router/main_basic.js